import { MARQUEE_ITEMS } from "../content";

const Diamond = () => (
  <svg viewBox="0 0 10 10" className="w-2.5 h-2.5 mx-8 text-[#D4AF37]/60 shrink-0" aria-hidden="true">
    <rect x="1.5" y="1.5" width="7" height="7" transform="rotate(45 5 5)" fill="currentColor" />
  </svg>
);

const Marquee = () => {
  const row = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div className="relative border-y border-[#D4AF37]/15 bg-[#06333E] py-5 overflow-hidden" data-testid="editorial-marquee">
      <div className="flex w-max animate-marquee items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center shrink-0">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center shrink-0">
                <span className="font-display text-sm tracking-[0.3em] text-[#F8FAFC]/70 whitespace-nowrap">{item}</span>
                <Diamond />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
